import React, { createContext, useState, useContext } from "react";
import { GetChartinks } from "../../services/backendServices";
import { toast } from "react-toastify";
// Create a context for chartinks Data 
export const ChartinkContext = createContext();
/*** ChartinkContextProvider: A provider component to manage and supplychartink data*/
export const ChartinkContextProvider = ({ children }) => {
    const [isChartinkDataLoading, setIsChartinkDataLoading] = useState(false); // State to track loading status forchartink data
    const [isChartinkDataFetched, setIsChartinkDataFetched] = useState(false); // State to track ifchartink data has been fetched
    const [chartinkData, setChartinkData] = useState([]); // State to storechartink data

    const fetchChartinksData = async ({ showToast = false } = {}) => {
        setIsChartinkDataLoading(true);
        try {
            const res = await GetChartinks();

            if (res.status) {
                setChartinkData(res.data);
                setIsChartinkDataFetched(true);
                if (showToast) toast.success("Chartink data refreshed successfully");
            } else {
                if (showToast) toast.error("Failed to fetch Chartink data");
            }
        } catch (e) {
            console.error("Error fetching chartink data:", e);
            if (showToast) toast.error("Error while fetching Chartink data");
        } finally {
            setIsChartinkDataLoading(false);
        }
    };

    //Function for refresh chartink data 
    const refreshChartinkData = () => fetchChartinksData({ showToast: true });


    //function to add chartink
    const addChartink = (resData) => {
        const updatedData = { ...resData, og_is_connected: false, og_place_order: true };
        //Add time stocks array add empty
        setChartinkData(prevData => [...prevData, { ...updatedData, stocks: [] }]);
    };
    // Function to update specific fields of a chartink
    const updateChartink = (chartink_id, updatedFields) => {
        setChartinkData((prevData) =>
            prevData.map((item) =>
                item.chartink_id === chartink_id ? { ...item, ...updatedFields } : item
            )
        );
    };
    // Function to remove Chartink
    const removeChartink = (chartink_id) => {
        setChartinkData((prevData) => prevData.filter((item) => item.chartink_id !== chartink_id));
    };
    // Function to add a new stock to a chartink
    const addChartinkStock = (chartink_id, newStock) => {
        setChartinkData((prevData) =>
            prevData.map((item) =>
                item.chartink_id === chartink_id
                    ? { ...item, "stocks": [...item.stocks, newStock] }
                    : item
            )
        );
    }
    // Function to update specific fields of a stock within a chartink
    const updateChartinkStock = (stock_id, updatedFields) => {
        setChartinkData((prevData) =>
            prevData.map((item) => {
                const updatedStocks = item.stocks.map((stock) =>
                    stock.stock_id === stock_id ? { ...stock, ...updatedFields } : stock
                );
                return { ...item, stocks: updatedStocks };
            })
        );
    }
    // Function to remove a stock from a chartink
    const removeChartinkStock = (stock_id) => {
        setChartinkData((prevData) =>
            prevData.map((item) => {
                const filteredStocks = item.stocks.filter((stock) => stock.stock_id !== stock_id);
                return { ...item, stocks: filteredStocks };
            })
        );
    }
    return (
        // The ChartinkContext.Provider component provides state and functions to the children components
        <ChartinkContext.Provider value={{
            isChartinkDataLoading, // State to track loading status forchartink data
            isChartinkDataFetched, // State to track ifchartink data has been fetched
            chartinkData, // State to storechartink data
            fetchChartinksData,  // Function to fetchchartink data
            refreshChartinkData, // Function to refreshchartink data
            setIsChartinkDataFetched, // Function to set the fetched status ofchartink data
            addChartink, //Function to add chartink
            updateChartink, //Function to update chartink
            removeChartink,  //Function to remove chartink 
            addChartinkStock, //Function to add stock to chartink
            updateChartinkStock, //Function to update stock of chartink
            removeChartinkStock //Function to remove stock from chartink
        }}>
            {children}
        </ChartinkContext.Provider>
    );
};
// Custom hook to access ChartinkContext data
export const useChartinkContext = () => {
    return useContext(ChartinkContext);
};